import { Component, Input } from '@angular/core';
import { Customer, CustomerNote } from '../../../../../../../models/customer';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from '../../../../../../../services/customer/customer.service';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../utils';

@Component({
  selector: 'app-add-customer-note-modal',
  templateUrl: './add-customer-note-modal.component.html',
  styleUrls: ['./add-customer-note-modal.component.css']
})
export class AddCustomerNoteModalComponent {

  @Input() customer: Customer;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public customerNote: CustomerNote = {
    id: null,
    url: '',
    title: '',
    note: '',
    is_removed: false,
    created_by_id: null,
    created_by_email: '',
    updated_by_id: null,
    updated_by_email: '',
    created_date: '',
    updated_date: '',
    created_at: '',
    updated_at: ''
  };

  public loadingSubmit = false;
  public errors: any = {};
  public errorMessage = '';
  public serverError: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    public customerService: CustomerService
  ) {}

  public handleSave() {
    this.loadingSubmit = true;

    this.errorMessage = '';

    this.customerService
      .addCustomerNote(
        this.customer.id,
        this.customerNote
      )
      .then(note => {
        this.savedCallback({
          text: 'Note \'' + note.title + '\' created successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to create customer notes.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

}
